import React from 'react';
import { Trash2 } from 'lucide-react';

export function buildSelectedPocsColumns(
  pocBudgets = {},
  onBudgetChange,
  onRemovePOC,
  {
    budgetHeader = 'Budget',
    budgetInputClassName = 'block w-full rounded-lg border-2 border-gray-100 pl-7 py-1.5 text-sm focus:border-blue-500 transition-all hover:border-gray-200 focus:outline-none',
    wrapperClassName = 'relative group animate-fadeIn',
    showOptimizedIcon = false,
    OptimizedIcon,
    optimizedIconClassName = 'text-blue-500',
    includeOverlapping = false,
  } = {}
) {
  const columns = [
    {
      key: 'poc_id',
      header: 'POC ID',
      width: '150px',
      headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
      cellClassName: 'px-4 py-3 text-sm font-mono text-gray-900',
    },
    {
      key: 'poc_name',
      header: 'POC Name',
      headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
      cellClassName: 'px-4 py-3 text-sm text-gray-900',
      render: (value) => value || 'N/A',
    },
    {
      key: 'budget',
      header: budgetHeader,
      width: '200px',
      headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
      cellClassName: 'px-4 py-3',
      render: (value, poc) => (
        <div className={wrapperClassName}>
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-400 text-xs">$</span>
          </div>
          <input
            type="number"
            value={pocBudgets[poc.poc_id] || ''}
            onChange={(e) => onBudgetChange && onBudgetChange(poc.poc_id, e.target.value)}
            placeholder="0"
            className={budgetInputClassName}
          />
          {showOptimizedIcon && OptimizedIcon && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <OptimizedIcon size={14} className={optimizedIconClassName} />
            </div>
          )}
        </div>
      ),
    },
  ];

  if (includeOverlapping) {
    columns.push({
      key: 'Overlapping',
      header: 'Overlapping',
      width: '120px',
      headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
      cellClassName: 'px-4 py-3 text-sm text-gray-900',
      render: (value, poc) => {
        if (poc.Overlapping === undefined || poc.Overlapping === null || poc.Overlapping === '-') return '-';
        const intVal = parseInt(poc.Overlapping, 10);
        return Number.isNaN(intVal) ? poc.Overlapping : intVal;
      },
    });
  }

  columns.push({
    key: 'action',
    header: 'Action',
    width: '100px',
    headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
    cellClassName: 'px-4 py-3',
    render: (value, poc) => (
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemovePOC && onRemovePOC(poc.poc_id);
        }}
        className="text-gray-300 hover:text-red-500 p-2 hover:bg-red-50 rounded-full transition-all"
        title="Remove from campaign"
      >
        <Trash2 size={18} />
      </button>
    ),
  });

  return columns;
}

/**
 * Column configuration for Selected POCs table (Manual Budget Mode)
 */
export const selectedPocsManualColumns = (pocBudgets = {}, onBudgetChange, onRemovePOC) =>
  buildSelectedPocsColumns(pocBudgets, onBudgetChange, onRemovePOC);
